import { useTranslation } from 'react-i18next';

import { Input } from '@treams/treams-ui';

import Property from './Property';

export default function Title(props: { label?: string; name?: string }) {
	const { t } = useTranslation();

	return (
		<Property title={props.label ?? t('common.settings.evaluationForms.properties.title.title')}>
			<Input.Localizable name={props.name ?? 'title'} />
		</Property>
	);
}
